import React from "react";
import ReactDOM from "react-dom";
import { MemoryRouter } from "react-router-dom";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import API_URL from "../Config";
import RoadClosureTemplate from "./RoadClosuereTemplate";

export const isExcavationPermit = (name = "") => {
  let value = String(name || "");
  try {
    value = decodeURIComponent(value);
  } catch {
    // A literal percent sign in a display name is not URL encoding.
  }
  return value.trim().toLowerCase().replace(/\s*\/\s*/g, "/") ===
    "excavation clearance/road closure";
};

export async function downloadExcavationPermitPdf(
  permitId,
  { isSidebarExpanded = false, preview = false } = {}
) {
  let container;
  try {
    if (permitId === null || permitId === undefined || permitId === "") {
      throw new Error("Missing excavation permit ID");
    }
    const headers = { Authorization: localStorage.getItem("authKey") };
    const [response, approvals, savedWorkDetails] = await Promise.all([
      axios.get(`${API_URL}/api/get_permit_details`, {
        headers,
        params: { permit_id: permitId },
      }),
      axios.get(`${API_URL}/api/permit/department/approvals/${permitId}`, {
        headers,
      }).catch(() => null),
      axios.get(`${API_URL}/api/get_permit_work_details/${permitId}`, {
        headers,
      }).catch(() => null),
    ]);
    if (response.status !== 200 || !response.data) {
      throw new Error("Unable to load excavation permit details");
    }
    const departmentApprovals =
      approvals?.data?.department_approvals ||
      response.data.departmentApprovals || [];

    container = document.createElement("div");
    Object.assign(container.style, {
      position: "fixed", left: "-10000px", top: "0", width: "1500px",
      padding: "0", margin: "0", background: "#d17f12",
    });
    document.body.appendChild(container);
    ReactDOM.render(
      <MemoryRouter>
        <RoadClosureTemplate
          permitDetails={{
            ...response.data,
            excavationWorkDetails: savedWorkDetails?.data?.permit_details?.[0] || {},
          }}
          departmentApprovals={departmentApprovals}
          isSidebarExpanded={isSidebarExpanded}
        />
      </MemoryRouter>,
      container
    );
    if (document.fonts?.ready) await document.fonts.ready;
    await Promise.all(Array.from(container.querySelectorAll("img")).map(
      (image) => image.decode ? image.decode().catch(() => {}) : Promise.resolve()
    ));
    const sections = [container.querySelector("#section1"), container.querySelector("#section2")];
    if (sections.some((section) => !section)) {
      throw new Error("Excavation PDF sections were not rendered");
    }
    const pdf = new jsPDF("p", "mm", "a4");
    for (const [index, section] of sections.entries()) {
      const canvas = await html2canvas(section, {
        scale: 1.8, useCORS: true, backgroundColor: "#d17f12",
        windowWidth: 1550, logging: false,
      });
      if (index) pdf.addPage();
      pdf.addImage(canvas.toDataURL("image/jpeg", 0.9), "JPEG", 5, 5, 200, 287);
    }
    if (preview) {
      const url = URL.createObjectURL(pdf.output("blob"));
      const tab = window.open(url, "_blank");
      if (!tab) pdf.save(`Excavation_Clearance_Road_Closure_Permit_${permitId}.pdf`);
      window.setTimeout(() => URL.revokeObjectURL(url), 60000);
    } else {
      pdf.save(`Excavation_Clearance_Road_Closure_Permit_${permitId}.pdf`);
    }
    return true;
  } catch (error) {
    console.error("Error downloading excavation permit PDF:", error);
    window.alert("Unable to download the excavation permit PDF. Please try again.");
    return false;
  } finally {
    if (container) {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
    }
  }
}
